import dayjs from 'utils/dayjs';
import Config from '@/config/index';
import { v4 as uuidV4 } from 'uuid';
import SearchTracking, { SEARCH_TRACKING_ACTIONS } from 'utils/search-tracking';
import { getMonthlyFacilities, getMonthlyFacilitiesLoadMoreSpots, } from 'api/search-v2/monthly/facilities/getMonthlyFacilities';
import { getSearchLimits } from 'utils/search-limits';
import { notify } from '../notification/notification-actions';
import trackErrorMessageDisplayed from 'segment/events/error-message-displayed';
import { getWebExperimentCookie } from 'utils/web-experiment';
import { getUrlParamAsObject, paramNameOptions } from 'utils/url-utils';
export const SPOTS_GET_MONTHLY_V2 = 'SPOTS_GET_MONTHLY_V2';
function handleError(dispatch, error) {
    trackErrorMessageDisplayed({
        message: 'Error fetching spots',
        screen: 'search',
        action: 'fetching spots',
    });
    dispatch(notify({
        id: uuidV4(),
        type: 'error',
        message: 'Error fetching spots',
    }));
    return {
        error: error?.data,
    };
}
export const loadSpotsMonthlyV2 = ({ searchTrackingAction, locationContext = undefined, mapCenter = undefined, mapBounds = undefined, searchLimit = undefined, }) => {
    return (dispatch, getState) => {
        const prevState = getState();
        const searchRequestState = prevState.searchRequest;
        const { latitude, longitude, starts, operator_id: operatorId, rebook_reservation_id: rebookId, filterSpot, } = searchRequestState;
        const userState = prevState.user;
        const { data: { isAdmin }, } = userState;
        const timezone = prevState.city.data.timezone;
        const fingerprint = getWebExperimentCookie();
        SearchTracking.updateAction(searchTrackingAction);
        const { sessionUUID, searchUUID, actionUUID, action, } = SearchTracking.getValues();
        const { resultLimit, maxDistance } = getSearchLimits({
            locationContext: locationContext === undefined ? '' : locationContext,
            mapCenter,
            mapBounds,
            searchLimit,
            isMonthly: true,
        });
        /* eslint-disable camelcase */
        return dispatch({
            type: SPOTS_GET_MONTHLY_V2,
            payload: getMonthlyFacilities({
                ...(mapCenter
                    ? {
                        origin_lat: latitude,
                        origin_lon: longitude,
                        lat: mapCenter.latitude,
                        lon: mapCenter.longitude,
                    }
                    : {
                        lat: latitude,
                        lon: longitude,
                    }),
                starts: dayjs(starts).format(Config.craigApiDateTimeFormat),
                show_unavailable: isAdmin,
                page_size: resultLimit,
                max_distance_meters: maxDistance,
                operator_id: operatorId,
                session_id: sessionUUID,
                search_id: searchUUID,
                action_id: actionUUID,
                action,
                fingerprint,
                ...getUrlParamAsObject(paramNameOptions.APPLY_PARTNER_CONFIG),
            }, {
                timezone,
                rebookId,
                filterSpot,
            }),
        }).catch((error) => handleError(dispatch, error));
        /* eslint-enable camelcase */
    };
};
export const loadMoreSpotsMonthlyV2 = () => {
    return (dispatch, getState) => {
        const prevState = getState();
        const loadMoreSpotsUrl = prevState.spots.loadMoreSpotsUrl;
        // empty loadMoreSpotsUrl (@next) indicates no more spots are available from api
        if (!loadMoreSpotsUrl) {
            return;
        }
        SearchTracking.updateAction(SEARCH_TRACKING_ACTIONS.LIST_SEARCH_NEXT);
        return dispatch({
            type: SPOTS_GET_MONTHLY_V2,
            payload: getMonthlyFacilitiesLoadMoreSpots({
                // Below includes walking distance until BE includes it in @next
                loadMoreSpotsUrl: `${loadMoreSpotsUrl}&include_walking_distance=true`,
            }, {})
                .then(response => ({
                loadMoreSpotsUrl: response.loadMoreSpotsUrl,
                results: [...prevState.spots.data, ...response.results], // append to existing spots
            }))
                .catch((error) => handleError(dispatch, error)),
        });
    };
};
